export const MAIN_PHONE_NUMBER_LINK = '88007758009'
export const MAIN_PHONE_NUMBER = '8 800 775 80 09'
export const WA_NUMBER = '79058090580'
export const MAIN_PHONE_NUMBER_RAW = '+78007758009'
